import React, { PureComponent } from "react";
import { CanvasOverlay } from "react-map-gl";
import { forEach } from "lodash";

// points is an array of [[lat, lon], [lat, lon], ...]
// <PolylineOverlay points={points} />
export default class PolylineOverlay extends PureComponent {
  _redraw({ width, height, ctx, isDragging, project }) {
    const { points, color = "yellow", lineWidth = 2, renderWhileDragging = true, opacity = 0.8 } = this.props;
    ctx.clearRect(0, 0, width, height);
    ctx.globalCompositeOperation = "lighter";

    if ((renderWhileDragging || !isDragging) && points) {
      ctx.lineWidth = lineWidth;
      ctx.strokeStyle = color;
      ctx.opacity = opacity;
      ctx.beginPath();
      forEach(points, point => {
        const pixel = project([point.lng, point.lat]);
        ctx.lineTo(pixel[0], pixel[1]);
      });
      ctx.stroke();
    }
  }

  render() {
    return <CanvasOverlay redraw={this._redraw.bind(this)} />;
  }
}
